import { render, staticRenderFns } from "./warehouseinboundconsumable.vue?vue&type=template&id=e90ede88&"
import script from "./warehouseinboundconsumable.vue?vue&type=script&lang=js&"
export * from "./warehouseinboundconsumable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports